import { useAuth0 } from '@auth0/auth0-react';
import { useMemo } from 'react';

/**
 * Hook to determine if the logged-in user is an internal Abyss user
 * based on their email domain containing "abysssolutions"
 */
export const useIsAbyssUser = (): boolean => {
  const { user } = useAuth0();

  const isAbyssUser = useMemo(() => {
    if (!user?.email) {
      return false;
    }

    // Extract domain from email (everything after @)
    const emailDomain = user.email.split('@')[1];

    // Check if domain contains "abysssolutions"
    return emailDomain?.toLowerCase().includes('abysssolutions') ?? false;
  }, [user?.email]);

  return isAbyssUser;
};
